import { AjaxClient } from "app/common/ajax";
import { MessageDisplay } from "app/common/message_display";
import * as $ from "jquery";

export class DbAdmin {
    public constructor(
        private readonly ajaxClient: AjaxClient,
        private readonly ajaxLoader: string,
        private readonly messageDisplay: MessageDisplay,
    ) {}

    public async populateProcessList(): Promise<void> {
        const tableBody = $('#processlist-table tbody');
        tableBody.html(`<tr><td colspan="6" class="center">${this.ajaxLoader}</td></tr>`);

        try {
            const result = await this.ajaxClient.call<IProcesslistAjaxResult[]>('/modpanel/system/dbadmin/processlist');
            tableBody.empty();
            for (const row of result) {
                tableBody.append(this.buildRow(row));
            }
        } catch (e) {
            this.messageDisplay.ajaxError(e as JQueryXHR);
        }
    }

    private buildRow(row: IProcesslistAjaxResult): string {
        return '<tr>'
           + `<td>${row.User}</td>`
           + `<td>${row.db}</td>`
           + `<td>${row.Command}</td>`
           + `<td>${row.State}</td>`
           + `<td>${row.Time}</td>`
           + `<td>${row.Info}</td>`
           + '</tr>';
    }
}

interface IProcesslistAjaxResult {
    User: string;
    db: string;
    Command: string;
    State: string;
    Time: string;
    Info: string;
}
